import { TooltipProvider } from '@bambi/component-library/src/components/Tooltip/Tooltip';
import { Provider as ReduxProvider } from 'react-redux';

import store from 'src/app/store/store';
import { configureAmplify } from 'src/common/external/aws';
import { PaymentMethodCaptureProvider } from 'src/common/forms/PaymentMethodCaptureForm/PaymentMethodCaptureContext';
import { RequiresConfirmationModal } from 'src/common/modals/RequiresConfirmationModal/RequiresConfirmationModal';
import { ToastConfigProvider } from 'src/common/primitives/Toast';
import { RequireAuth } from 'src/features/auth/requireAuth';
import ChatProvider from 'src/features/chat/ChatProvider';

import { useDatadogLogger } from '../common/external/datadog/useDatadogLogger';
import { Routing } from './app.routes';
import { DelinquentBanner } from './banner/DelinquentBanner';
import { MissingHeadquartersBanner } from './banner/MissingHeadquartersBanner';
import { TimeDriftBanner } from './banner/TimeDriftBanner';

configureAmplify();

function App() {
  useDatadogLogger();

  return (
    <div className="App">
      <ReduxProvider store={store}>
        <ToastConfigProvider>
          <TooltipProvider delayDuration={200}>
            <RequireAuth>
              <ChatProvider>
                <PaymentMethodCaptureProvider>
                  <DelinquentBanner />
                  <TimeDriftBanner />
                  <MissingHeadquartersBanner />
                  <Routing />
                  <RequiresConfirmationModal />
                </PaymentMethodCaptureProvider>
              </ChatProvider>
            </RequireAuth>
          </TooltipProvider>
        </ToastConfigProvider>
      </ReduxProvider>
    </div>
  );
}

export default App;
